<app-section>
    <app-section-header [title]="'Explora Carreras Universitarias'"
        [descriptions]=
        "['Descubre una amplia variedad de carreras universitarias y encuentra la opción perfecta para tu futuro.'
        , 'Explora programas académicos de diferentes facultades, conoce sus detalles y marca tus favoritas ❤️ para tenerlas siempre a la mano.']">
    </app-section-header>
    <app-university-careers-list></app-university-careers-list>
</app-section>